<template>
    <flickity :options="flickityOptions" class="orsus-new-release">
        <div 
            v-for="(release, index) in releases" 
            :key="index" 
            class="carousel-cell md:bg-white-two w-full mb-24 md:mb-48 md:h-card-md mx-4 px-10 text-charcoal-grey md:shadow-lg md:relative"
            >
            <div class="bg-white-two px-6 pt-4 md:px-0 relative md:static">
                <div class="mt-3 md:mt-6 -mb-6">
                    <h3 class="text-lg md:text-4xxl font-futura mb-2">{{ release.title }}</h3>
                    <p class="font-light">{{ shortenText(release.description) }}</p>
                </div>
                <img :src="release.imagePath" alt="" class="md:absolute -mb-10 pin-b pin-x shadow md:shadow-lg mx-auto translate-y-1/4">
            </div>
        </div>
    </flickity>
</template>

<script>
import Flickity from 'vue-flickity';
import { screens } from '../../../../tailwind.js';
import 'flickity-imagesloaded';
import { truncate } from 'lodash';

export default {
    components: {
        Flickity
    },
    data() {
        return {
            flickityOptions: {
                prevNextButtons: false,
                imagesLoaded: true,
                groupCells: true,
                contain: true,
                cellAlign: 'left'
            },
            releases: [
                {
                    title: 'Dance Revolution',
                    description: 'A first of its kind digital talent hunt to find the best of the Dance Talent in colleges across India, unique Intercollegiate Dance Championship exclusively on The Remo D’Souza App and Digital PlatformsBrought to you by India’s No.1 director, producer & dance reality show Judge– Remo D’souza.',
                    imagePath: '/assets/images/orsus_new_releases-1.jpg'
                },
                {
                    title: 'So Toca Top',
                    description: 'A first of its kind digital talent hunt to find the best of the Dance Talent in colleges across India, unique Intercollegiate Dance Championship exclusively on The Remo D’Souza App and Digital PlatformsBrought to you by India’s No.1 director, producer & dance reality show Judge– Remo D’souza.',
                    imagePath: '/assets/images/orsus_new_releases-2.jpg'
                }
            ]
        }
    },
    methods: {
        shortenText(text) {
            if(!window.matchMedia(`(min-width: ${ screens.md } )`).matches) {
                return truncate(
                    text,
                    {
                        'length': 92,
                        'separator': ' '
                    }
                );
            }

            return text;
        }
    }
}
</script>

